import { useSearchParams } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import { getUserResource, setUserResource } from "../services/login";

async function LoginCallback(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  let code = searchParams.get('auth_code')
  if (code) {
    let response = await getUserResource(code)
    if(response!==null) {
      await setUserResource(response)
      window.location.href = `${process.env.REACT_APP_BASE_PATH}`
    }
  }
  return <CircularProgress sx={{height:'100%'}}></CircularProgress>

}
export default LoginCallback;